import Vue from 'vue';
import App from './App.vue';
import router from './router';

import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';

import FontAwesomeBuilder from '@/utils/fontawesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import AppHeader from '@/components/header.vue';

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);
FontAwesomeBuilder.buildLibrary();

const httpLink = new HttpLink({
  uri: 'https://wedding-invites-db.hasura.app/v1/graphql',
  headers: {
    'x-hasura-admin-secret': 'VM5IVyDu5RYi5xpHtL42MeGJ2tzv1hh4xrcRkKrjlfVVaKdxZekf6YW5WkhGOhSt'
  }
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

new Vue({
  router,
  apolloProvider,
  render: (h) => h(App, {}, [
    h(Vue.component('app-header', AppHeader)),
  ]),
}).$mount('#app');
